import { FiltrosAnuncios } from '..'
import { axiosInstanceMain } from '../../../utils/axiosGlobalUtils'
import { ITenant } from '../../AbmLocalPage/types'
import { INITIAL_ROWS_PER_PAGE } from '../../Products/components/TableDataPagination'
import { AnuncioDTO } from '../types/anuncios.types'

export const getAnunciosABM = async (tenant: ITenant, filtros: FiltrosAnuncios) => {
  const params = new URLSearchParams(
    Object.entries({
      ...filtros,
      pagina: filtros.pagina + 1 || 1,
      pageSize: filtros.pageSize || INITIAL_ROWS_PER_PAGE
    })
      .filter(([, v]) => v !== null && v !== undefined)
      .map(([k, v]) => [k, String(v)])
  )

  return axiosInstanceMain.get(`admin/${tenant.path}/anuncios${params.toString() ? `?${params.toString()}` : ''}`)
}

export const getDetalleAnuncio = async (tenant: ITenant, idAnuncio: number) =>
  await axiosInstanceMain.get(`admin/${tenant.path}/anuncios/${idAnuncio}`)

export const deleteAnuncio = async (tenant: ITenant, idAnuncio: number) =>
  await axiosInstanceMain.delete(`admin/${tenant.path}/anuncios/${idAnuncio}`)

export const getTiposAnuncio = async (tenant: ITenant) =>
  await axiosInstanceMain(`admin/${tenant.path}/anuncios/tipos-de-anuncio`)

export const getAnunciantes = async (tenant: ITenant) =>
  await axiosInstanceMain(`admin/${tenant.path}/anuncios/anunciantes`)

export const updateAnuncio = async (tenant: ITenant, id: number, anuncio: AnuncioDTO) =>
  await axiosInstanceMain.put(`admin/${tenant.path}/anuncios/${id}`, anuncio)

export const crearAnuncio = async (tenant: ITenant, anuncio: AnuncioDTO) =>
  await axiosInstanceMain.post(`admin/${tenant.path}/anuncios`, anuncio)
